import GameUtils from '../gameutils';
import { createMessage } from '../createMessage';
import { Status } from '../../lib/constants';
// import HELPERS from '../../lib/globals/helpers/Helpers'

export function login(that, status) {
	const session = GameUtils.getParameterByName('session', '', that);
	if (typeof session === 'string') {
		const loginMsg = createMessage('auth', session);
		that.sendMessage(loginMsg);
	} else {
		console.error(
			`%cnot logged in ${status};`,
			'color: white; background: red;'
		);
	}
}

export function statusHelper(status, that) {
	// console.log('%cstatus =', 'color:brown', status)
	switch (status) {
		case Status.CONNECTED:
			console.log(
				'%cCONNECTED!',
				'color:black; background: green; border-radius: 4px; padding: 10px; font-size: 16px'
			);
			login(that, status);
			break;
		case Status.DISCONNECTED:
			console.log(
				'%cDISCONNECTED :(',
				'color:white; background: red; padding: 10px; font-size: 16px'
			);
			that.onReceiveMessage({
				data: JSON.stringify({ service: 'disconnect' })
			});
			break;

		default:
			break;
	}
}
